import { useEffect, useRef } from "react";
import { WS_URL } from "../lib/api";

// Subscribes to backend websocket. Calls onMessage(parsed) for each message.
export function useRealtime(onMessage) {
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  useEffect(() => {
    let ws;
    let closed = false;
    let retry;

    const connect = () => {
      ws = new WebSocket(WS_URL);
      ws.onmessage = (e) => {
        try { cbRef.current(JSON.parse(e.data)); } catch (_) {}
      };
      ws.onclose = () => {
        if (!closed) retry = setTimeout(connect, 2000);
      };
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retry);
      if (ws) ws.close();
    };
  }, []);
}
